import {
  ArnConditionExecutionOptions,
  ArnConditionService,
} from './ArnConditionService';
import {
  ArnConditionExecResults,
  ArnConditionsPayload,
} from '@arianee/arn-types';
import { ArnConditionContext } from './ArnConditionContext';
import { ArnErc721ConditionService } from './erc721/ArnErc721ConditionService';
import { ArnArianeeNftConditionService } from './arianee';
import { ArnUserConditionService } from './user';
import { ArnHttpConditionService } from './http';

export abstract class ArnAbstractConditionService
  implements ArnConditionService
{
  protected _context: ArnConditionContext | undefined;

  inContext(context: ArnConditionContext | undefined): this {
    this._context = context;
    return this;
  }

  get context(): ArnConditionContext | undefined {
    return this._context;
  }

  async execute(
    payload: ArnConditionsPayload,
    _options?: ArnConditionExecutionOptions
  ): Promise<ArnConditionExecResults> {
    const result = this._context?.cache.get(payload);
    if (!result) {
      return { success: false, executions: [] };
    }
    return result;
  }

  abstract get arianee(): ArnArianeeNftConditionService;

  abstract get erc721(): ArnErc721ConditionService;

  abstract get user(): ArnUserConditionService;

  abstract get http(): ArnHttpConditionService;
}
